import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'uima';

  ngOnInit() {
    // Override sekali, berlaku semua JSON.stringify di seluruh aplikasi
    Date.prototype.toJSON = function() {
      const year = this.getFullYear();
      const month = String(this.getMonth() + 1).padStart(2, '0');
      const day = String(this.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
}